import React from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import ProductCountCustomTooltip from '@features/trend-research/components/common/ProductCountCustomTooltip';

import { capitalizeFirstLetter, getNumberUnit } from '@utils/Util';

const ProductCountBarChart = ({ chartLabels, chartData }) => {
	const maxBarsVisible = 20;
	const barWidth = 100;
	const chartWidth = chartData?.length > maxBarsVisible ? chartData?.length * barWidth : '100%';

	const formatYAxis = (tick) => {
		return getNumberUnit(tick);
	};

	const customFormatter = (value, name) => {
		return [getNumberUnit(value), capitalizeFirstLetter(name)];
	};

	return (
		<div className="" style={{ height: 200 }}>
			<ResponsiveContainer width={chartWidth} className={'scroll-x-label'}>
				<BarChart
					data={chartData}
					style={{
						fontSize: '0.8rem',
						fontWeight: 'normal',
						fontFamily: 'Inter'
					}}
					barCategoryGap={50}
				>
					<CartesianGrid stroke="#f5f5f5" />
					<XAxis dataKey="name" />
					<YAxis tickFormatter={formatYAxis} />
					<Tooltip
						content={<ProductCountCustomTooltip active={false} payload={[]} label={''} />}
						cursor={{ fill: 'transparent' }}
						formatter={customFormatter}
					/>
					{chartLabels.map((bar) => (
						<Bar
							key={`bar_${bar.dataKey}`}
							barSize={15}
							dataKey={bar.dataKey}
							fill={bar.fill}
							radius={[7, 0, 0, 0]}
						/>
					))}
				</BarChart>
			</ResponsiveContainer>
		</div>
	);
};

export default ProductCountBarChart;
